export default __webpack_public_path__ + "static/media/calendar-prev.03390ce7.svg";